import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import MapHome from "@/pages/MapHome";
import AdminPanel from "@/pages/AdminPanel";
import AuthProvider from "@/contexts/AuthContext";

function AppFrame() {
  const location = useLocation();
  const pathname = location?.pathname || "/";
  const isMapRoute = pathname === "/" || pathname === "/green" || pathname === "/disco";

  // Body overflow is controlled here so non-map pages (ex: /admin) can scroll.
  // This avoids global `overflow: hidden` preventing scroll on long pages.
  useEffect(() => {
    document.body.classList.toggle("mapix-no-scroll", isMapRoute);
    return () => document.body.classList.remove("mapix-no-scroll");
  }, [isMapRoute]);

  const appShellClass = isMapRoute
    ? "App h-screen w-screen overflow-hidden"
    : "App min-h-screen w-full overflow-visible";

  return (
    <div className={appShellClass}>
      <Routes>
        <Route path="/" element={<MapHome initialTheme="simple" initialCategory="All" />} />
        <Route path="/green" element={<MapHome initialTheme="green" initialCategory="All" />} />
        <Route path="/disco" element={<MapHome initialTheme="disco" initialCategory="Disco" />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppFrame />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
